import { render, staticRenderFns } from "./MinisiteLanding.vue?vue&type=template&id=3a59f374&scoped=true&"
import script from "./MinisiteLanding.vue?vue&type=script&lang=js&"
export * from "./MinisiteLanding.vue?vue&type=script&lang=js&"
import style0 from "./MinisiteLanding.vue?vue&type=style&index=0&id=3a59f374&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a59f374",
  null
  
)

export default component.exports